import requestService from '@/js/common/Domain/Service/request';
import getABTestValue from '@/js/common/Domain/Service/getABTestValue';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    url: `${window.appConfig.apiGatewayUrl}/frontend/railwaysTours`,
    data: {
        ...tourCriteriaForTourRequest,
        allToursPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'firstPaymentDefinitions', 'routes', 'stations'],
        abTests: getABTestValue(),
    },
}, callback);